<template>
  <div v-if="visible">
    <div class="loader">
      <i></i>
    </div>
    <div class="overlay">
      <i></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: ["visible"]
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 800;
}

.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  height: 85px;
  width: 85px;
  border-radius: 50%;
  z-index: 900;
  text-align: center;
  i {
    display: block;
    margin: 0 auto;
    &:before {
      content: ".";
      animation-name: load;
      animation-duration: 800ms;
      animation-iteration-count: infinite;
      width: auto;
      color: black;
      display: inline-block;
      font-size: 40px;
    }
  }
}

@keyframes load {
  0% {
    content: ".";
  }
  33% {
    content: "..";
  }
  66% {
    content: "...";
  }
  100% {
    content: ".";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Loader.vue